import { ButtonControl } from "appworks/ui/controls/standard/button/button-control";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { UIElements } from "gameiom/wrapper/wrapper-data";

export class AgsDepositButtonControl extends ButtonControl {
    public setEnabled(enabled: boolean): void {
        const displayDepositPageButton: boolean = gameiomModel.displayButtons.get(UIElements.depositPageButton);
        this.setVisible(displayDepositPageButton);

        super.setEnabled(enabled);
    }

    public setVisible(displayDepositPageButton: boolean) {
        this.button.setVisible(displayDepositPageButton);
    }

    protected onClick(): void {
        gameWrapper.gotoDepositPage();
        super.onClick();
    }
}
